import { render, staticRenderFns } from "./QuestionValueList.vue?vue&type=template&id=6f0a3c94&scoped=true&"
import script from "./QuestionValueList.vue?vue&type=script&lang=ts&"
export * from "./QuestionValueList.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionValueList.vue?vue&type=style&index=0&id=6f0a3c94&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a3c94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0a3c94')) {
      api.createRecord('6f0a3c94', component.options)
    } else {
      api.reload('6f0a3c94', component.options)
    }
    module.hot.accept("./QuestionValueList.vue?vue&type=template&id=6f0a3c94&scoped=true&", function () {
      api.rerender('6f0a3c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/groups/questions/newQuestion/newQuestionValues/QuestionValueList.vue"
export default component.exports